import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

export interface IConfirmationModalData {
  title: string;
  paragraphs: string[];
  actions?: {
    positive?: string;
    negative?: string;
  };
  responses?: {
    positive?: any;
    negative?: any;
  };
}

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.sass'],
})
export class ConfirmationModalComponent {
  titleLabel: string;
  paragraphLabels: string[];
  positiveActionLabel = 'Sí';
  negativeActionLabel = 'No';

  private positiveResponse: any = true;
  private negativeResponse: any = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: IConfirmationModalData,
    private dialog: MatDialogRef<ConfirmationModalComponent>
  ) {
    this.titleLabel = this.data.title;
    this.paragraphLabels = this.paragraphLabels;
    if (this.data.actions) {
      if ('positive' in this.data.actions) {
        this.positiveActionLabel = this.data.actions.positive;
      }
      if ('negative' in this.data.actions) {
        this.negativeActionLabel = this.data.actions.negative;
      }
    }
    if (this.data.responses) {
      if ('positive' in this.data.responses) {
        this.positiveResponse = this.data.responses.positive;
      }
      if ('negative' in this.data.responses) {
        this.negativeResponse = this.data.responses.negative;
      }
    }
  }

  onClickPositive(): void {
    this.dialog.close(this.positiveResponse);
  }

  onClickNegative(): void {
    this.dialog.close(this.negativeResponse);
  }
}
